import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import Pagination from "./Pagination";
import { paginate } from "../../scripts/helperScripts";
import Input from "./Input";
import Table from "./Table";
import Select from "./Select";
import { getErrorLogs } from "../services/soar";

function ErrorLogs() {
  const [errorLogs, setErrorLogs] = useState([]);
  const [beginDate, setBeginDate] = useState(
    moment().subtract(1, "months").format(moment.HTML5_FMT.DATE)
  );
  const [endDate, setEndDate] = useState(
    moment().format(moment.HTML5_FMT.DATE)
  );
  const [connection, setConnection] = useState("SOARD365Base");
  const [selectedError, setSelectedError] = useState("");

  const [totalCount, setTotalCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState({
    path: "logWhenUTC",
    order: "desc",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const isMountedRef = useRef(true);
  const pageSize = 10;

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const loadErrorLogs = () => {
    const toastId = toast.loading("Loading Error Logs...", {
      type: toast.TYPE.INFO,
    });
    getErrorLogs(connection, beginDate, endDate).then((logs) => {
      if (logs && isMountedRef.current) {
        const errors = JSON.parse(logs).ErrorLog.Errors;
        setErrorLogs(errors);

        if (errors.length > 0) {
          toast.update(toastId, {
            render: "Error Logs loaded.",
            isLoading: false,
            type: toast.TYPE.SUCCESS,
            autoClose: 5000,
            closeOnClick: true,
          });
        } else {
          toast.update(toastId, {
            render: "No Error Logs available for selected date range.",
            isLoading: false,
            type: toast.TYPE.WARNING,
            autoClose: 5000,
            closeOnClick: true,
          });
        }
      } else {
        toast.update(toastId, {
          render: "An error occurred while loading the Error Logs.",
          isLoading: false,
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          closeOnClick: true,
        });
      }
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSort = (sortColumn) => {
    setSortColumn(sortColumn);
  };

  const getPagedData = () => {
    const filtered =
      searchQuery !== ""
        ? errorLogs.filter((log) =>
            log.logWho.toLowerCase().includes(searchQuery.toLowerCase())
          )
        : errorLogs;

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    if (totalCount !== sorted.length) setTotalCount(sorted.length);

    const history = paginate(sorted, currentPage, pageSize);
    return history;
  };

  const handleSearchQueryChange = ({ currentTarget: input }) => {
    setSearchQuery(input.value);
  };

  const columns = [
    {
      key: "Timeout",
      content: (error) => {
        if (error.logResponseMessage) {
          const responseMessage = error.logResponseMessage.toLowerCase();
          if (
            responseMessage.includes("timeout") ||
            responseMessage.includes(
              "metadata contains a reference that cannot be resolved"
            ) ||
            responseMessage.includes("there was no endpoint listening")
          )
            return <i className="far fa-clock"></i>;
        }
      },
    },
    {
      key: "Who",
      path: "logWho",
      label: "Who",
      content: (error) => {
        return error.logWho.split("|")[0];
      },
    },
    {
      key: "Application",
      path: "logApplication",
      label: "Application",
    },
    {
      key: "Entity",
      label: "Regarding",
      content: (error) => {
        if (error.logURL.includes("entityName=")) {
          const entityName = error.logURL.split("entityName=")[1];
          return entityName.slice(0, entityName.indexOf("&"));
        }
        return null;
      },
    },
    {
      key: "When",
      path: "logWhenUTC",
      label: "Date",
      content: (error) => moment(error.logWhenUTC + "-0000").format("LLL"),
    },
  ];

  return (
    <>
      <>
        <div className="container">
          <div className="row">
            <div className="col">
              <Select
                name="Connection"
                label="Connection"
                options={[
                  { _id: "ReactTest", name: "Workers Test" },
                  { _id: "ReactLive", name: "Workers Production" },
                  { _id: "ParentsTest", name: "Parents Test" },
                  { _id: "ParentsLive", name: "Parents Production" },
                ]}
                value={connection}
                onChange={({ currentTarget: input }) => {
                  setConnection(input.value);
                }}
              />
            </div>
            <div className="col">
              <Input
                name="BeginDate"
                label="Begin Date"
                type="date"
                value={beginDate}
                onChange={({ currentTarget: input }) => {
                  setBeginDate(input.value);
                }}
              />
            </div>
            <div className="col">
              <Input
                name="EndDate"
                label="End Date"
                type="date"
                value={endDate}
                onChange={({ currentTarget: input }) => {
                  setEndDate(input.value);
                }}
              />
            </div>
            <div className="col">
              <button
                style={{ marginTop: "30px" }}
                className="btn btn-primary"
                onClick={loadErrorLogs}
              >
                Load Error Logs
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                name="SearchQuery"
                label="Search"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={handleSearchQueryChange}
              />
            </div>
            <div className="col">
              <i
                style={{ marginTop: "35px" }}
                className="fas fa-window-close fa-2x text-danger float-start"
                onClick={() => {
                  setSearchQuery("");
                }}
              ></i>
            </div>
            <div className="col"></div>
            <div className="col">
              <div className="mt-3">
                <a
                  href={
                    connection === "SOARD365Base"
                      ? "https://safy365.sharepoint.com/:x:/s/SOARDevelopment/EU2QSYAqtPZLmyzFY_OND8sB6c7TKspdGSR_1_urTVsEmA?e=7LfFsX"
                      : "https://safy365.sharepoint.com/:x:/s/SOARDevelopment/EcMjA7b5GdRHi-hZrQx3MRYBPVSS3G-W0MZtTrGKgm3LAw?e=iBUdFH"
                  }
                  target="_blank"
                >
                  ObjectTypeCode Reference
                </a>
              </div>
            </div>
          </div>
        </div>
        <Table
          columns={columns}
          data={getPagedData()}
          sortColumn={sortColumn}
          onSort={handleSort}
          idColumn="logId"
          selectedId={selectedError}
          setSelectedId={setSelectedError}
        />
        <div className="row justify-content-center">
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </>
    </>
  );
}

export default ErrorLogs;
